import { requestInvitationApi } from './requestApi'
import { DeviceType } from '@app/hooks/useUserDevice'
import { CreateInvitationData, CustomPromise, Invitation } from '@app/types/invitations'

export const fetchInvitation = (code: string, token: string): CustomPromise<Invitation> => {
  return requestInvitationApi({
    path: `invitations/${code}/${token}`,
    resourceName: 'invitation',
  })
}

type ConfirmAuthorizationParams = { publicToken: string; lastPanNumbers: string }

export const checkConfirmAuthorizations = ({
  publicToken,
  lastPanNumbers,
}: ConfirmAuthorizationParams): CustomPromise<{ id: string }> => {
  return requestInvitationApi({
    path: `check_confirm_authorizations/${publicToken}/${lastPanNumbers}`,
    resourceName: 'invitation',
  })
}

type VerifyPhoneNumberParams = { code: string; token: string; phoneNumber: string }
type VerifyPhoneNumberBody = { phone_number: string }

export const verifyPhoneNumber = ({ phoneNumber, code, token }: VerifyPhoneNumberParams): Promise<void> => {
  const body: VerifyPhoneNumberBody = {
    phone_number: phoneNumber,
  }

  return requestInvitationApi({
    method: 'POST',
    path: `invitations/${code}/${token}/phone_number_verification`,
    body,
  })
}

export const createInvitation = (
  code: string,
  token: string,
  phoneCode: string,
  payload: CreateInvitationData,
  origin?: {
    platform: string
    device?: DeviceType
  },
): Promise<void> => {
  return requestInvitationApi({
    path: `invitations/${code}/${token}`,
    method: 'PATCH',
    body: {
      user: {
        first_name: payload.firstname,
        last_name: payload.lastname,
        email: payload.email,
        phone_number: payload.phoneNumbers,
        password: payload.password,
      },
      phone_number_verification: {
        code: phoneCode,
      },
      origin,
    },
  })
}

export const sendNewInvitation = ({ email }: { email: string }): Promise<unknown> => {
  return requestInvitationApi({
    path: 'invitations/sending',
    method: 'POST',
    body: {
      email,
    },
  })
}
